// extracted by mini-css-extract-plugin
module.exports = {"dataGridWithoutShadow":"dataGridWithoutShadow___3SRLI"};